module.exports = __webpack_public_path__ + "static/media/sap.730514fe.jpeg";